import { render } from "./FlaggedClientPosts.vue?vue&type=template&id=6f40a68c&ts=true"
import script from "./FlaggedClientPosts.vue?vue&type=script&lang=ts"
export * from "./FlaggedClientPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__